import produce from 'immer';
import createCachedSelector from 're-reselect';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { getType } from 'typesafe-actions';
import { actions } from '..';
import { parseMsDate } from '../../api';
import { toObject } from '../../data-utils';
import { Access, AdditionalConfig, AgentStatistic, ApplicationSetting, Config, DeviceGroup, Dirty, ExtensionDevice, Identifier, LocationType, PresenceMap, QueueOrSquadId, QueueRegionId, Region, SettingType, TaskState } from '../../model';
import { setEnhancedIntegration, setFeaturePhoneBusySetCallback, setFeaturePhoneDial, updateApplicationSetting, updateCallAssistants } from '../actions';
import { Actions, StoreState } from '../types';

function config(state: Config | null = null, action: Actions): Config | null {

  //formate foramtes to work in teams
  function formatDateTimeFormat(value: string): string {
    return value.replace("dddd", "****")
      .replace("yyyy", "YYYY")
      .replace("tt", "a")
      .replace("TT", "A")
      .replace("dd", "DD")
      .replace("d", "D")
      .replace("****", "dddd");
  }

  if (action.type === getType(actions.setConfig)) {
    const {
      version,
      ipAddress,
      clientId,
      serverName,
      extension,
      sessionPingTimeInterval,
      locations,
      breakCodes,
      regions,
      features,
      isLync,
      isLicensedCallRecording,
      isTeamsPbx,
      isScreenRecording,
      currentDeviceGroup,
      primaryDevice,
      devices,
      baseUserLevel,
      featureClassId,
      firstName,
      lastName,
      fullName,
      officeExtension,
      associateNumber,
      mobile,
      homeNumber,
      otherNumber,
      screenCapture,
      userRegion,
      canReceiveVoicemail,
      vmExtensions,
      agentDisplayName,
      wrapupSingleSelect,
      agentStats,
      agentLimits,

      dateTimeLongFormat,
      dateTimeShortFormat,
      shortTimeFormat,
      longTimeFormat,
      shortDateFormat,
      longDateFormat,

      command,
      vMPortExtensions,
      rescheduleWrapupDuration,

      defaultWorkTime,

      requestId,
      sessionId,
      imEnabled,
      imAllowBlockedMessagesSentAsEmails,
      imBlockMessageInLocation,

      taskStates,

      department,
      expertise,
      siteSpecificExpertise,

      applicationSettings,
      callAssistants,

      canMonitor,
      teamsEnhancedCti,
      preReleaseFeatures,

      turnServer,
      turnServerUdp,
      turnServerTcp,
      janus,
      realm,

      operatorNotes,
      activity,
      teamsEnhanced,
      emailAttachmentPreview,
      // TODO: we should remove this because a this list of queues where the queue agent is a member of.
      // On the server side, this list never changes. Shanes has made provision on the server side that this
      // list is now on demand. 
      myQueues,
      clientDebugging,
      transcriptionEnabled,
      mediaQueueTwitter,
      mediaQueueFacebook,
      mediaQueueEmail,
      mediaQueueWebChat,
      autoLocnExpiry,
      monitorGroups,
      localServerTimeZoneBias,
      showMainToolbar = true,
    } = action.payload

    const r = regions.map(r => ({
      server: r.serverName,
      id: r.id,
      name: r.name,
      countryCode: r.countryCode,
      localAreaCode: r.localAreaCode,
      nationalAccessCode: r.nationalAccessCode,
      localNumberLength: r.localNumberLength,
      timeBias: r.timeBias,
    } as Region))

    const settings = applicationSettings.map(a => ({
      applicationSettingId: a.applicationSettingId,
      applicationId: a.applicationId,
      settingType: a.settingType,
      identifier: a.identifier,
      value: a.value,
      extensionId: a.extensionId,
      dirty: a.dirty,
      lastUpdated: parseMsDate(a.lastUpdated, true),
    })) as ApplicationSetting[]

    return {
      version,
      ipAddress,
      clientId,
      serverName,
      extension,
      sessionPingTimeInterval,
      presence: toObject(locations, loc => loc.id, loc => { return { id: loc.id, description: loc.description, defaultReturnTimeId: loc.defaultReturnTimeId } as LocationType }),
      breakCodes: toObject(breakCodes, b => b.key, b => b.value),
      regionId: userRegion.id,
      regions: r,
      queueRegions: [...Object.values(QueueRegionId), ...r],
      devices: devices.map(d => {
        return {
          number: d.number.toLowerCase(),
          baseType: d.baseType,
          deviceSubType: d.deviceSubType,
          canReceiveVm: d.canReceiveVm,
          tenant: d.tenant,
          pbxActionBitMask: d.pbxActionBitMask,
          description: d.description,
        }
      }),
      baseUserLevel,
      featureClassId,
      primaryDevice: primaryDevice.number.toLowerCase(),
      currentDeviceGroup,

      firstName,
      lastName,
      fullName,

      officeExtension,
      associateNumber,
      mobile,
      homeNumber,
      otherNumber,
      screenCapture,
      vmExtensions,

      canReceiveVoicemail,

      access: {
        isTeamsPbx: state?.access.isTeamsPbx ? true : isTeamsPbx,
        isScreenRecording: isScreenRecording,
        isLyncLicensed: isLync,
        isCallRecordingLicensed: isLicensedCallRecording,
        canMonitor: canMonitor,
        features,
      },

      agentDisplayName: {
        applicationSettingId: agentDisplayName.applicationSettingId,
        applicationId: agentDisplayName.applicationId,
        settingType: agentDisplayName.settingType,
        identifier: agentDisplayName.identifier,
        value: agentDisplayName.value,
        extensionId: agentDisplayName.extensionId,
        dirty: agentDisplayName.dirty,
        lastUpdated: parseMsDate(agentDisplayName.lastUpdated, true),
      } as ApplicationSetting,

      wrapupSingleSelect,

      agentStatistic: agentStats,

      agentLimits: agentLimits,

      dateTimeLongFormat: formatDateTimeFormat(dateTimeLongFormat),
      dateTimeShortFormat: formatDateTimeFormat(dateTimeShortFormat),
      shortTimeFormat: formatDateTimeFormat(shortTimeFormat),
      longTimeFormat: formatDateTimeFormat(longTimeFormat),
      shortDateFormat: formatDateTimeFormat(shortDateFormat),
      longDateFormat: formatDateTimeFormat(longDateFormat),

      command,
      vMPortExtensions,
      rescheduleWrapupDuration,

      defaultWorkTime,

      requestId,
      sessionId,
      imEnabled,
      imAllowBlockedMessagesSentAsEmails,
      imBlockMessageInLocation,

      taskStates,

      department,
      expertise,
      siteSpecificExpertise,

      applicationSettings: settings,
      callAssistants,

      canMonitor,
      teamsEnhancedCti,
      preReleaseFeatures,

      turnServer,
      turnServerUdp,
      turnServerTcp,
      janus,
      realm,

      operatorNotes,
      activity,
      teamsEnhanced,
      emailAttachmentPreview,
      myQueues: myQueues.map(x => x.key),
      clientDebugging,
      transcriptionEnabled,
      mediaQueueTwitter,
      mediaQueueFacebook,
      mediaQueueEmail,
      mediaQueueWebChat,
      autoLocnExpiry,
      monitorGroups,
      localServerTimeZoneBias,
      showMainToolbar,
    }
  }

  if (action.type === getType(actions.setSocketId)) {
    if (state === null) return state

    return { ...state, socketId: action.payload }
  }

  if (action.type === getType(actions.updateCurrentDeviceGroup)) {
    const currentDeviceGroup = action.payload
    if (state === null) return state

    return { ...state, currentDeviceGroup }

  }

  if (action.type === getType(actions.updatePrimaryDevice)) {
    const primaryDevice = action.payload
    if (state === null) return state

    return { ...state, primaryDevice }
  }

  if (action.type === getType(actions.showMainToolbar)) {
    const showMainToolbar = action.payload
    if (state === null) return state

    return { ...state, showMainToolbar }
  }  

  if (action.type === getType(actions.updateStaticData)) {
    const { id, firstName, lastName, office, other, mobile, home, associateNumber, regionId, devices } = action.payload

    if (state === null || id.id !== state.extension || id.server !== state.serverName) return state

    return {
      ...state,
      firstName,
      lastName,
      officeExtension: office,
      otherNumber: other,
      mobile,
      homeNumber: home,
      associateNumber: associateNumber,
      regionId: regionId,
      devices,
    }
  }

  if (action.type === getType(actions.loadAgentStats)) {
    const { agentId: extension, stats } = action.payload

    if (state === null) return state
    if (state.extension !== extension || !stats) return state

    return {
      ...state,
      agentStatistic: stats,
    }
  }

  if (action.type === getType(actions.updateAgentDisplayName)) {
    const { value } = action.payload

    if (state === null) return state
    const agent = state.agentDisplayName

    return {
      ...state,
      agentDisplayName: { ...agent, value },
    }
  }

  if (action.type === getType(actions.instantMessagerSettingsUpdate)) {
    const { imEnabled, imAllowBlockedMessagesSentAsEmails, imBlockMessageInLocation } = action.payload

    if (state === null) return state

    const valueImEnabled = imEnabled === undefined ? state.imEnabled : imEnabled
    const valueImAllowBlockedMessagesSentAsEmails = imAllowBlockedMessagesSentAsEmails === undefined ? state.imAllowBlockedMessagesSentAsEmails : imAllowBlockedMessagesSentAsEmails
    const valueImBlockMessageInLocation = imBlockMessageInLocation === undefined ? state.imBlockMessageInLocation : imBlockMessageInLocation

    return {
      ...state,
      imEnabled: valueImEnabled,
      imAllowBlockedMessagesSentAsEmails: valueImAllowBlockedMessagesSentAsEmails,
      imBlockMessageInLocation: valueImBlockMessageInLocation,
    }
  }

  if (action.type === getType(updateApplicationSetting)) {
    return produce(state, state => {
      const { setting } = action.payload

      if (state) {
        const settings = state.applicationSettings.filter(a => a.settingType !== setting.settingType)
        settings.push({ ...setting, dirty: Dirty.None })

        state.applicationSettings = settings
      }
    })
  }

  if (action.type === getType(updateCallAssistants)) {
    if (state === null) return state
    const { data } = action.payload
    return {
      ...state,
      callAssistants: data,
    }
  }

  if (action.type === getType(setEnhancedIntegration)) {
    if (state === null) return state
    return {
      ...state,
      teamsEnhancedCti: action.payload.on,
    }
  }

  if (action.type === getType(setFeaturePhoneDial)) {
    return produce(state, state => {
      if (state === null) return state
      state.access.features.phoneDial = action.payload.on
    })
  }

  if (action.type === getType(setFeaturePhoneBusySetCallback)) {
    return produce(state, state => {
      if (state === null) return state
      state.access.features.phoneBusySetCallback = action.payload.on
    })
  }


  if (action.type === getType(actions.updateExtensionTable)) {

    return produce(state, state => {
      const { id, autoAnswer, imageDate } = action.payload
      if (state === null || state.extension !== id.id || state.serverName !== id.server) return state

      state.imageDateTime = imageDate

      const auto = state.applicationSettings.find(a => a.settingType === 'ExtensionAutoAnswer')
      if (!auto) return state
      auto.value = autoAnswer === 4 ? 'true' : 'false'

    })
  }

  return state
}

function additionalConfig(state: AdditionalConfig = {}, action: Actions): AdditionalConfig {
  if (action.type === getType(actions.setAdditionalConfig)) {
    return { ...state, ...action.payload }
  }

  return state
}

function singleQueueOrSquad(state: QueueOrSquadId | null = null, action: Actions): QueueOrSquadId | null {
  if (action.type === getType(actions.showSingleQueueOrSquad)) {
    return action.payload
  }

  return state
}

function focus(state: boolean = true, action: Actions): boolean {
  if (action.type === getType(actions.setFocus)) {
    return action.payload
  }

  return state
}

export default combineReducers({
  config,
  additionalConfig,
  singleQueueOrSquad,
  focus,
})

function getRoot(state: StoreState) {
  return state.config
}

export function getConfig(state: StoreState) {
  return getRoot(state).config
}

export function getFoucs(state: StoreState) {
  return getRoot(state).focus
}

export const selectMyself = createSelector(
  (s: StoreState) => selectConfigProp(s, 'serverName'),
  (s: StoreState) => selectConfigProp(s, 'extension'),
  function (serverName, extension): Identifier | null {
    if (!serverName || !extension) return null
    return {
      server: serverName,
      id: extension,
    }
  },
)

export interface BookitSettings {
  clientId: string,
  ipAddress: string,
}


export const selectBookitSettings = createSelector(
  (s: StoreState) => selectConfigProp(s, 'clientId'),
  (s: StoreState) => selectConfigProp(s, 'ipAddress'),
  function (clientId, ipAddress): BookitSettings | null {
    if (!clientId || !ipAddress) return null
    return {
      clientId: clientId,
      ipAddress: ipAddress,
    }
  },
)

export const selectCallAssisants = createSelector(
  (s: StoreState) => selectConfigProp(s, 'callAssistants'),
  (assistants): Identifier[] => {
    if (!assistants) {
      return []
    }
    return assistants.map(a => { return { id: a.targetExtension, server: a.targetExtensionServer } as Identifier })
  },
)

export const selectPresenceMap = createSelector(
  (s: StoreState) => selectConfigProp(s, 'presence'),
  (s: StoreState) => selectConfigProp(s, 'breakCodes'),
  (presence, breakCodes): PresenceMap => {
    if (!presence || !breakCodes) {
      return {
        presence: {},
        breakCodes: {},
      }
    }
    return { presence, breakCodes }
  },
)

export function selectConfigProp<T extends keyof Config>(state: StoreState, prop: T): Config[T] | undefined;
export function selectConfigProp<T extends keyof Config>(state: StoreState, prop: T, def: Config[T]): Config[T];
export function selectConfigProp<T extends keyof Config>(state: StoreState, prop: T, def?: Config[T]): Config[T] | undefined {
  const config = getConfig(state)
  return config ? config[prop] : def
}

const noRegions = Object.values(QueueRegionId)
export function selectQueueRegions(state: StoreState) {
  return selectConfigProp(state, 'queueRegions', noRegions)
}

export function selectRegions(state: StoreState) {
  return selectConfigProp(state, 'regions')
}

export function selectIsExpertise(state: StoreState) {
  return selectConfigProp(state, 'siteSpecificExpertise')
}

function getAdditionalConfig(state: StoreState) {
  return getRoot(state).additionalConfig
}

export function selectFavQueueFolderId(state: StoreState) {
  return getAdditionalConfig(state).favouriteQueuesFolderId
}

export function selectFavExtensionFolderId(state: StoreState) {
  return getAdditionalConfig(state).favouriteExtensionFolderId
}

export function selectFavContactFolderId(state: StoreState) {
  return getAdditionalConfig(state).favouriteContactFolderId
}

export function selectShortcutFolderId(state: StoreState) {
  return getAdditionalConfig(state).shortcutFolderId
}

const defaultAccess: Access = { features: {} }

export function selectMyAccess(state: StoreState): Access {
  const config = getRoot(state).config;
  return config ? config.access : defaultAccess
}

export function selectVoicemailPorts(state: StoreState): string[] {
  const config = getRoot(state).config;
  return config ? config.vMPortExtensions : []
}

export function selectShowMainToolbar(state: StoreState) {
  return selectConfigProp(state, 'showMainToolbar')
}

export interface MyDevices {
  primaryDevice: ExtensionDevice,
  devices: ExtensionDevice[],
}

//probably need to split this up some more
export const selectMyDevices = createSelector(
  (s: StoreState) => selectConfigProp(s, 'devices'),
  (s: StoreState) => selectConfigProp(s, 'primaryDevice'),
  (devices, primaryDevice): MyDevices | null => {
    if (!devices || !primaryDevice) { return null }
    return {
      primaryDevice: devices.filter(d => d.number === primaryDevice)[0],
      devices: devices,
    }
  })

export interface WecRtcSettings {
  sipDomain?: string;
  turnServer: string;
  turnServerUdpPort: string;
  turnServerTcpPort: string;
  turnUsername?: string;
  turnPassword?: string;
  janus: string;
  sipRealm?: string;
  serverUsername?: string;
  serverPassword?: string;
}

let selectWecRtcSettingsCache: WecRtcSettings | null = null
export const selectWecRtcSettings = createSelector(
  (s: StoreState) => {
    const data = getConfig(s)
    let d: WecRtcSettings | null = null
    if (data) {
      d = {
        janus: data.janus,
        turnServer: data.turnServer,
        turnServerTcpPort: data.turnServerTcp,
        turnServerUdpPort: data.turnServerUdp,
        sipRealm: data.realm,
      }
    }
    //compare proeprties
    if (selectWecRtcSettingsCache === null || d !== null && Object.entries(selectWecRtcSettingsCache).toString() !== Object.entries(d).toString()) {
      selectWecRtcSettingsCache = d
    }
    return selectWecRtcSettingsCache
  },
  (data): WecRtcSettings | null => {
    return data
  })

export interface MyData {
  server: string
  extension: string
  office: string
  mobile: string
  home: string
  other: string
  associate: string
  firstname: string
  lastname: string
  fullName: string
  canReceiveVoicemail: boolean
  regionId: string
  imageDateTime?: string
}

let myDataCache: MyData | null = null
export const selectMyData = createSelector(
  (s: StoreState) => {
    const data = getConfig(s)
    let d: MyData | null = null
    if (data) {
      d = {
        server: data.serverName,
        extension: data.extension,
        office: data.officeExtension,
        mobile: data.mobile,
        home: data.homeNumber,
        other: data.otherNumber,
        associate: data.associateNumber,
        firstname: data.firstName,
        lastname: data.lastName,
        fullName: data.fullName,
        canReceiveVoicemail: data.canReceiveVoicemail,
        regionId: data.regionId,
        imageDateTime: data.imageDateTime,
      }
    }

    //compare proeprties
    if (myDataCache === null || d !== null && Object.entries(myDataCache).toString() !== Object.entries(d).toString()) {
      myDataCache = d
    }
    return myDataCache
  },
  (data): MyData | null => {
    return data
  })

export const selectMyRegionId = createSelector(
  (s: StoreState) => selectConfigProp(s, 'regionId'),
  (data): string | null => {
    return !data ? null : data
  })

export const selectStatistics = createSelector(
  (s: StoreState) => selectConfigProp(s, 'agentStatistic'),
  (data): AgentStatistic | null => {
    return !data ? null : data
  })


export const selectMyRegion = createSelector(
  (s: StoreState) => selectConfigProp(s, 'regionId'),
  (s: StoreState) => selectConfigProp(s, 'regions'),
  (regionId, regions): Region | null => {
    if (!regionId || !regions) { return null }

    for (const r of regions) {
      if (typeof r !== 'string' && r.id === regionId) {
        return r
      }
    }

    return null
  })

export const selectTaskStates = createSelector(
  (s: StoreState) => selectConfigProp(s, 'taskStates'),
  (data): TaskState[] | null => {
    return !data ? null : data
  })

export function selectExtendedAvailablePresenceEnabled(state: StoreState) {
  const access = selectMyAccess(state)
  return Boolean(!access.isLyncLicensed && access.features.extensionExtendedAvailablePresence)
}

export const selectCurrentDeviceGroup = createSelector(
  (s: StoreState) => selectConfigProp(s, 'currentDeviceGroup'),
  (data): DeviceGroup | null => {
    return !data ? null : data
  })

export const selectDefaultWorkTime = createSelector(
  (s: StoreState) => selectConfigProp(s, 'defaultWorkTime'),
  (data): number | null => {
    return !data ? null : data
  })


export const selectDateFormating = createSelector(
  (s: StoreState) => selectConfigProp(s, 'dateTimeLongFormat'),
  (s: StoreState) => selectConfigProp(s, 'dateTimeShortFormat'),
  (s: StoreState) => selectConfigProp(s, 'shortTimeFormat'),
  (s: StoreState) => selectConfigProp(s, 'longTimeFormat'),
  (s: StoreState) => selectConfigProp(s, 'shortDateFormat'),
  (s: StoreState) => selectConfigProp(s, 'longDateFormat'),
  (dateTimeLongFormat, dateTimeShortFormat, shortTimeFormat, longTimeFormat, shortDateFormat, longDateFormat) => {
    if (!dateTimeLongFormat || !dateTimeShortFormat || !shortTimeFormat || !longTimeFormat || !shortDateFormat || !longDateFormat) return null
    return {
      dateTimeLongFormat,
      dateTimeShortFormat,
      shortTimeFormat,
      longTimeFormat,
      shortDateFormat,
      longDateFormat,
    }
  })

export const selectInstantMessagerSettings = createSelector(
  (s: StoreState) => selectConfigProp(s, 'imEnabled'),
  (s: StoreState) => selectConfigProp(s, 'imBlockMessageInLocation'),
  (s: StoreState) => selectConfigProp(s, 'imAllowBlockedMessagesSentAsEmails'),
  (imEnabled, imBlockMessageInLocation, imAllowBlockedMessagesSentAsEmails) => {
    if (imEnabled === undefined || imBlockMessageInLocation === undefined || imAllowBlockedMessagesSentAsEmails === undefined) { return null }
    return {
      imEnabled,
      imBlockMessageInLocation,
      imAllowBlockedMessagesSentAsEmails,
    }
  })


export const selectRescheduleWrapupDuration = createSelector(
  (s: StoreState) => selectConfigProp(s, 'rescheduleWrapupDuration'),
  (rescheduleWrapupDuration) => {
    if (!rescheduleWrapupDuration) { return null }
    return rescheduleWrapupDuration
  })

export function selectSingleQueueOrSquad(state: StoreState) {
  return getRoot(state).singleQueueOrSquad
}

export function selectIsSingleQueueOrSquad(state: StoreState) {
  return Boolean(selectSingleQueueOrSquad(state))
}

export const selectApplicationSetting = createCachedSelector(
  (s: StoreState) => selectConfigProp(s, 'applicationSettings'),
  (s: StoreState, settingType: SettingType) => settingType,
  (applicationSettings, settingType) => {
    if (!applicationSettings || !settingType) { return null }

    return applicationSettings.find(x => x.settingType === settingType)
  },
)(
  (_, settingType) => settingType,
)

export function selectIsWebRtcEnabled(state: StoreState) {
  const webRtcEnabled = selectApplicationSetting(state, 'WebRtcEnabled')
  return (webRtcEnabled && webRtcEnabled.value === '1') || false
}

export function selectShowShortcutsToolbar(state: StoreState) {
  const showShortcutsToolbar = selectApplicationSetting(state, 'ShowShortcutsToolbar')
  return (showShortcutsToolbar && showShortcutsToolbar.value === '1') || false
}

export function selectCallNotificationsShowOnIncoming(state: StoreState) {
  const callNotificationsShowOnIncoming = selectApplicationSetting(state, 'CallNotificationsShowOnIncoming')
  return (callNotificationsShowOnIncoming && callNotificationsShowOnIncoming.value === 'true') || false
}

export function selectCallNotificationsShowOnOutgoing(state: StoreState) {
  const callNotificationsShowOnOutgoing = selectApplicationSetting(state, 'CallNotificationsShowOnOutgoingCall')
  return (callNotificationsShowOnOutgoing && callNotificationsShowOnOutgoing.value === 'true') || false
}

export function selectCallNotificationsShowOnMissed(state: StoreState) {
  const callNotificationsShowOnMissed = selectApplicationSetting(state, 'CallNotificationsShowOnMissed')
  return (callNotificationsShowOnMissed && callNotificationsShowOnMissed.value === 'true') || false
}

export function selectShowQueueAlerts(state: StoreState) {
  const ShowQueueAlerts = selectApplicationSetting(state, 'OptionsQueueAlertsPop')
  return (ShowQueueAlerts && ShowQueueAlerts.value === 'true') || false
}

export function selectAwayFromDeskTimeoutSeconds(state: StoreState) {
  const showShortcutsToolbar = selectApplicationSetting(state, 'AwayFromDeskTimeoutSeconds')
  try {
    if ( showShortcutsToolbar ) {
      return parseInt(showShortcutsToolbar.value)
    }
  } catch {
    // do nothing, default to 300
  }
  return 300
}

export const selectAdvancedEmailSearchEnabled = createSelector(
  (s: StoreState) => {
    const x = selectConfigProp(s, 'preReleaseFeatures')
    return !x ? false : x.indexOf('email-search') !== -1
  },
  (data): boolean => {
    return data
  })
